export default __webpack_public_path__ + "static/media/icons8-search.dcf5b5e8.svg";